import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

import { filterItemPickerStyle } from '../../../constants/gamefilters';

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <FontAwesomeIcon icon={faCaretDown} />
  </components.DropdownIndicator>
);

export default class FilterItemPicker extends PureComponent {
  render() {
    const {
      options, value, onChange, id,
    } = this.props;

    return (
      <Select
        isClearable
        styles={filterItemPickerStyle}
        components={{ DropdownIndicator }}
        id={id}
        instanceId={id}
        options={options}
        value={value}
        onChange={onChange}
      />
    );
  }
}

FilterItemPicker.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onChange: PropTypes.func.isRequired,
};
